import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import theme from 'shared/styles/theme';

export const SafePayOn = () => {
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'learningCenter',
  });
  return (
    <View style={styles.OuterContainer}>
      <BodyBaseText>
        {translatedText('howToBuildCredit.safePayOnString.stringOne')}
      </BodyBaseText>
      <View style={styles.contentList}>
        <ContentList
          contentList={[
            translatedText('howToBuildCredit.safePayOnString.bullets.one'),
            translatedText('howToBuildCredit.safePayOnString.bullets.two'),
          ]}
        />
      </View>
      <BodyBaseText>
        {translatedText('howToBuildCredit.safePayOnString.stringTwo')}
      </BodyBaseText>
    </View>
  );
};
const styles = StyleSheet.create({
  OuterContainer: {
    flex: 1,
    width: '100%',
  },
  contentList: {
    marginVertical: theme.spacing.m,
    rowGap: theme.spacing.s,
  },
});
